import Consumer from "./Consumer";
import RelationOneToOne from "./RelationOneToOne";
import Terminal from "./Terminal";

export default class RelationConsumerToTerminal extends RelationOneToOne<Terminal> {
  get toClassNames(): Array<string> {
    return ["Terminal"]; // no itx
  }

  constructor(from: Consumer) {
    super({
      from: from,
      fromClassName: "Consumer",
      backReferencePropertyName: "_consumer",
    });
  }
}
